import { ConditionalRender } from '@/features/layouts/components/ConditionalRender';
import { ImageRead } from './Image.read';
import { ImageWrite, type Props as ReadAndWriteProps } from './Image.write';

export const Image = ({ recommended, ...readProps }: ReadAndWriteProps) => {
  return (
    <ConditionalRender
      read={<ImageRead {...readProps} />}
      write={<ImageWrite recommended={recommended} {...readProps} />}
    />
  );
};
